var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAccessWishlist = function SvgAccessWishlist(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 110,
    viewBox: "0 0 114 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1112_5343",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 110,
    height: 110
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    rx: 10,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1112_5343)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 98.7755,
    cy: 50.5102,
    r: 21.3265,
    fill: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.7041,
    cy: 88.1122,
    r: 7.29592,
    fill: "#E7FCDD"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.265 62.6411C103.265 58.4211 99.6893 55 95.2783 55H74.2097C69.7987 55 66.2245 58.4211 66.2245 62.6411V96.7041C66.2245 99.3753 67.6831 101.853 70.07 103.238C72.4587 104.623 75.4288 104.714 77.9055 103.479L84.3758 100.248C84.5485 100.162 84.7563 100.161 84.9307 100.247L91.6248 103.541C94.0998 104.76 97.061 104.657 99.4374 103.27C101.814 101.883 103.265 99.4107 103.265 96.7479V62.6411Z",
    fill: "url(#paint0_linear_1112_5343)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.4864 86.2571C84.1012 86.2275 83.7433 86.0794 83.4544 85.8423L83.3112 85.714C83.3112 85.714 78.5413 80.9465 75.0256 77.4284C73.7023 76.1051 72.9592 74.3127 72.9592 72.4412C72.9592 70.5698 73.7023 68.7749 75.0256 67.4516C75.0256 67.4516 75.0281 67.4516 75.0281 67.4491C76.3514 66.1283 78.1438 65.3827 80.0152 65.3827C81.7138 65.3827 83.3482 65.995 84.6247 67.0986C85.9011 65.9999 87.533 65.3901 89.2291 65.3901C91.1005 65.3901 92.8954 66.1332 94.2187 67.4566C95.5421 68.7799 96.2852 70.5748 96.2852 72.4462C96.2852 74.3176 95.5421 76.1125 94.2187 77.4358C90.703 80.9515 85.9356 85.7189 85.9356 85.7189C85.5875 86.067 85.116 86.2621 84.6247 86.2621L84.4864 86.2571Z",
    fill: "url(#paint1_linear_1112_5343)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1112_5343",
    x1: 103.265,
    y1: 55,
    x2: 66.2245,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37405,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746912,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1112_5343",
    x1: 84.5185,
    y1: 72.7622,
    x2: 84.5185,
    y2: 114.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C055D"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAccessWishlist);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/access-wishlist.42e7c6bb295d9f6eab15783da91f0b58.svg";